import React from "react";
import { TopSection } from "./topSection";
import { Services } from "../../components/services"
import { EmploymentAd } from "../../components/employment"
import { PageContainer } from "../../components/pageContainer";
import { About } from "../../components/about";
// import { Blog } from "../../components/blog";
import { BlogHomePage } from "../BlogHomePage/BlogHomePage.jsx";




export function HomePage(props){
	 
// const [isOpen,setIsOpen] = useState(false)

// const toggle =()=>{setIsOpen(!isOpen)};


	return (
		<>
			<PageContainer>
				<TopSection />
				<About />
				<BlogHomePage/>
				<Services />
				<EmploymentAd />
			</PageContainer>
		</>
	);
}
